export default {
  allMarkets: {
    id: 'listings_import_modal_market_all',
    defaultMessage: 'All markets',
  },
  comma: {
    id: 'listings_import_modal_delimiter_comma',
    defaultMessage: ', (comma)',
  },
  delimiterLabel: {
    id: 'listings_import_modal_fields_delimiter_label',
    defaultMessage: 'Separator',
  },
  encodingLabel: {
    id: 'listings_import_modal_fields_encoding_label',
    defaultMessage: 'Encoding',
  },
  fileLabel: {
    id: 'listings_import_modal_fields_file_label',
    defaultMessage: 'My file',
  },
  formMandatoryError: {
    id: 'listings_actions_form_mandatory_error',
    defaultMessage: 'This field is mandatory',
  },
  market: {
    id: 'listings_import_modal_fields_market_label',
    defaultMessage: 'Market',
  },
  marketSelectReminder: {
    id: 'listings_import_modal_market_reminder',
    defaultMessage:
      'Don\'t forget: with all markets you need a "lang" column in your CSV.',
  },
  publicationState: {
    id: 'listings_actions_form_publication_state',
    defaultMessage: 'Publication state',
  },
  selectDelimiter: {
    id: 'listings_actions_form_select_delimiter',
    defaultMessage: 'Select delimiter',
  },
  selectEncoding: {
    id: 'listings_actions_form_select_encoding',
    defaultMessage: 'Select encoding',
  },
  selectFile: {
    id: 'listings_actions_form_select_file',
    defaultMessage: 'Select your file',
  },
  selectMarket: {
    id: 'listings_actions_form_select_market',
    defaultMessage: 'Select market',
  },
  selectPublicationStates: {
    id: 'listings_actions_form_select_publication_state',
    defaultMessage: 'Select publication state',
  },
  semicolon: {
    id: 'listings_import_modal_delimiter_semicolon',
    defaultMessage: '; (semicolon)',
  },
  tab: {
    id: 'listings_import_modal_delimiter_tab',
    defaultMessage: '\t (tab)',
  },
  formatDescription: {
    id: 'listings_action_form_format_description',
    defaultMessage: 'in CSV format',
  },
  csvCreationTitle: {
    id: 'listings_action_form_cvs_creation_title',
    defaultMessage: 'Need help creating a CSV file?',
  },
  csvCreationContent: {
    id: 'listings_action_form_cvs_creation_content',
    defaultMessage: 'No worries.',
  },
  csvCreationButton: {
    id: 'listings_action_form_cvs_creation_button',
    defaultMessage: 'Generate CSV file',
  },
  allPublicationStates: {
    id: 'listings_actions_form_all_publication_states',
    defaultMessage: 'All publication states',
  },
  publicationStateMissingInformation: {
    id: 'listings_link_missing_infos',
    defaultMessage: 'Missing information',
  },
  publicationStateInValidation: {
    id: 'listings_link_in_validation',
    defaultMessage: 'In validation',
  },
  publicationStateOnline: {
    id: 'listings_link_active',
    defaultMessage: 'Active',
  },
  publicationStateOffline: {
    id: 'listings_link_archived',
    defaultMessage: 'Archived',
  },
  export: {
    id: 'listings_export_modal_submit',
    defaultMessage: 'Export',
  },
  import: {
    id: 'listings_actions_panel_import',
    defaultMessage: 'Import',
  },
  update: {
    id: 'listings_actions_panel_update',
    defaultMessage: 'Update',
  },
  exportInformation: {
    id: 'listings_export_modal_description',
    defaultMessage:
      'You will export your offers in CSV format, the export will NOT take into account applied search filters.',
  },
  importInformation: {
    id: 'listings_import_modal_description',
    defaultMessage:
      'Import new listings using a CSV file, please click on the below link to generate a template.',
  },
  updateInformation: {
    id: 'listings_update_modal_description',
    defaultMessage:
      'Update new listings using a CSV file, please click on the below link to generate a template.',
  },
  exportListingHeaderText: {
    id: 'seller_listings_actions_export_header',
    defaultMessage: 'Download all of your listings as a CSV file. ',
  },
  importListingHeaderText: {
    id: 'seller_listings_actions_import_header',
    defaultMessage:
      'Create listings of existing items by uploading a CSV file.',
  },
  updateListingHeaderText: {
    id: 'seller_listings_actions_update_header',
    defaultMessage:
      'Update existing listings and stock by uploading a CSV file.',
  },

  openBlankCsv: {
    id: 'seller_listings_actions_open_blank_csv',
    defaultMessage: 'Open a blank CSV file and add 3 columns:',
  },
  fillOutListingDetails: {
    id: 'seller_listings_actions_fill_out_details',
    defaultMessage: 'Fill out your listing details.',
  },
  uploadFinalCsv: {
    id: 'seller_listings_actions_upload_final_csv',
    defaultMessage: 'Upload the final CSV file.',
  },
  sku: {
    id: 'seller_listings_actions_info_block_sku',
    defaultMessage: 'SKU',
  },
  stock: {
    id: 'seller_listings_actions_info_block_stock',
    defaultMessage: 'Stock',
  },
  price: {
    id: 'seller_listings_actions_info_block_price',
    defaultMessage: 'Price',
  },
  generateCsv: {
    id: 'seller_listings_actions_generate_csv',
    defaultMessage: 'Generate the CSV file here',
  },
  stateColumnHint: {
    id: 'seller_listings_actions_state_column_hint',
    defaultMessage:
      'In the CSV template, the “state” column is your item’s appearance. Enter the following values for each appearance grade:',
  },
  mintState: {
    id: 'seller_listings_actions_mint_state',
    defaultMessage: '0 = Mint',
  },
  veryGoodState: {
    id: 'seller_listings_actions_very_good_state',
    defaultMessage: '1 = Very good',
  },
  goodState: {
    id: 'seller_listings_actions_good_state',
    defaultMessage: '2 = Good',
  },
  fairState: {
    id: 'seller_listings_actions_fair_state',
    defaultMessage: '3 = Fair',
  },
  stalloneState: {
    id: 'seller_listings_actions_stallone_state',
    defaultMessage: '4 = Stallone',
  },
  premiumState: {
    id: 'seller_listings_actions_premium_state',
    defaultMessage: '5 = Premium',
  },
}
